//
// CREATE COOKIE FOR HP NEWS - first time visit show
//
$(document).ready(function() {
    if (document.cookie.indexOf("visited=") >= 0) {
        // They've been here before.

    } else {
        // First-time visit
        $(".c-homepageNewsBox").animateCss("fadeInLeft");
        $(".c-homepageNewsBox").toggleClass("opened");
        setTimeout(closeHpNews, 5000);
        document.cookie = "visited=yes";
    }
});

$(function () {
    $.nette.init();

    $.nette.ext('ajax-spinner', {
        start: function () {
            $('#ajax-spinner').fadeIn();
        },
        complete: function () {
            $('#ajax-spinner').fadeOut();
        }
    });
});

//
// ANIMATE CSS
//
$.fn.extend({
    animateCss: function (animationName, callback) {
        var animationEnd = (function (el) {
            var animations = {
                animation: 'animationend',
                OAnimation: 'oAnimationEnd',
                MozAnimation: 'mozAnimationEnd',
                WebkitAnimation: 'webkitAnimationEnd',
            };

            for (var t in animations) {
                if (el.style[t] !== undefined) {
                    return animations[t];
                }
            }
        })(document.createElement('div'));

        this.addClass('animated ' + animationName).one(animationEnd, function () {
            $(this).removeClass('animated ' + animationName);

            if (typeof callback === 'function') callback();
        });

        return this;
    },
});

//
// RESPONS SIGNPOST TOOGLER
//
$(".signpostButton").click(function (e) {
    e.preventDefault();

    var parent = $(this).closest(".c-signpostResponsBox");

    parent.find(".boxLinks").toggleClass("opened");
    $(this).toggleClass("opened");
});

//
// Close HP News
//
var closeHpNews = function() {
    $(".c-homepageNewsBox").animateCss("bounceOutLeft");
    setTimeout(function () {
        $(".c-homepageNewsBox").removeClass("opened");
    }, 500);
};

//
// OPEN || CLOSE MAIN DESKTOP MENU
//
var submenuOpened = false;

$("#openSubMenu").click(function (e) {
    e.preventDefault();

    if (!submenuOpened) {
        $(".c-ourDisciplines").show().animateCss("fadeInRight");
        $(".c-touchableBox").addClass("visible");
        submenuOpened = true;
    } else {
        $(".c-ourDisciplines").hide();
        $(".c-touchableBox").removeClass("visible");
        submenuOpened = false;
    }
});

$("#closeMainMenu").click(function (e) {
    e.preventDefault();

    $(".c-ourDisciplines").fadeOut();
    $(".c-touchableBox").removeClass("visible");
    submenuOpened = false;

    setTimeout(function () {
        $(".c-ourDisciplines").hide();
    }, 1000);
});

/* close all windows on click on touchableBox */
$(".c-touchableBox").click(function (e) {
    e.preventDefault();

    /* Close submenu */
    if (submenuOpened) {
        $(".c-ourDisciplines").hide();
        submenuOpened = false;
    }

    /* Close HP News */
    if ($(".c-homepageNewsBox").hasClass("opened")) {
        closeHpNews();
    }

    /* Close search box */
    if ($(".searchBoxLayout").hasClass("opened")) {
        $(".c-closeSearch ").each(function () {
            $(this).css("display", "none");
        });
        $(".searchBoxLayout").removeClass("opened");
    }

    $(".c-touchableBox").removeClass("visible");
});

//
// SUBPAGE (PLASTIC) SUBMENU MOBILE TOGGLER
//
$(".c-subpageHeaderBox").find(".mobileButonnsDropdown").click(function (e) {
    e.preventDefault();

    $(this).toggleClass("opened");
    $(".c-subpageHeaderBox").find(".buttonsBox").toggleClass("opened");
});

//
// MOBILE MAIN MENU TOGGLER
//

/* Open main menu */
$("#openMobileMenu").click(function (e) {
    e.preventDefault();
    $(".o-mobileMainMenu").addClass("opened");
});

/* CLose main menu */
$("#closeMenuMobileMenu").click(function (e) {
    e.preventDefault();
    $(".o-mobileMainMenu").removeClass("opened");
});

/* Open submenu boxes */
// $(".c-menuBox.u-topBlock").click(function (e) {
//     e.preventDefault();
//     $(this).closest(".menuLine").toggleClass("opened");
// });

//
// HEADER SEARCH FORM SCRIPTS
//

/*
// If is not opened search window, open it
*/
$(".searchBoxLayout").on("click", "#openSearch", function (e) {
    e.preventDefault();

    if (!$(".searchBoxLayout").hasClass("opened")) {
        $(".searchBoxLayout").addClass("opened");

        $(".c-touchableBox").addClass("visible");
        //$(".searchBoxLayout").find("#searchButton").text($(this).attr("data-opened"));

        // Show search close button
        setTimeout(function () {
            $(".c-closeSearch ").each(function () {
                $(this).css("display", "block");
            });
        }, 500);
    }
});

$(".searchBoxLayout").on("click", "#closeSearch", function (e) {
    e.preventDefault();

    $(".c-closeSearch ").each(function () {
        $(this).css("display", "none");
    });
    $(".searchBoxLayout").removeClass("opened");

    $(".c-touchableBox").removeClass("visible");
});


//
// TOGGLE NEWS HOMEPAGE BOX
//

$(".c-homepageNewsBox").on("click", ".handler", function () {
    if ($(".c-homepageNewsBox").hasClass("opened")) {
        closeHpNews();
    } else{
        $(".c-homepageNewsBox").animateCss("fadeInLeft");
        $(".c-homepageNewsBox").toggleClass("opened");
    }
    if ($(".c-homepageNewsBox").hasClass("opened")) {
        $(".c-touchableBox").addClass("visible");
    } else {
        $(".c-touchableBox").removeClass("visible");
    }
});

//
// FAQ
//
$('.o-faqBox').on('click', '.c-question .c-anchor', function (e) {
    e.preventDefault();

    $(this).parent().toggleClass('active');
    $(this).parent().find('.c-answer-text').slideToggle();
});

//
// MASONRY LIBRARY
//

function setMasonry() {
    $('.c-personsDetailBox').masonry({
        itemSelector: '.c-detailPersonalItem',
        columnWidth: '.virtualBox',
        gutter: 20,
        percentPosition: true
    });
}

//
// SPECIALIST PAGE TOGGLE DETAIL BOX
//
$(".c-detailPersonalItem").has(".openDetail").find(".titleBox").on("click", function () {
    $(".c-detailPersonalItem").removeClass("opened");

    $(this).closest(".c-detailPersonalItem").addClass("opened");
    isOpened = true;

    setMasonry();
});

var mobile = false;

function ourSpecialistsInit() {
    var isVisible = false;
    $(".c-personsDetailBox").each(function (index) {
        if ($(this).hasClass("visible")) {
            isVisible = true;
        }
    });

    if (!isVisible) {
        $(".c-personsDetailBox").first().addClass("visible");
    }

    if ($(window).width() <= 768) {
        $(".c-personsDetailBox").each(function (index) {
            $(this).removeAttr("style");
            $(this).find(".c-detailPersonalItem").removeAttr("style");

            if ($(this).hasClass("visible")) {
                $(this).find(".c-detailPersonalItem").removeClass("opened");
                $(this).find(".c-detailPersonalItem").first().addClass("opened");
            }
        });

        mobile = true;
    } else {
        if (mobile === true) {
            $(".c-personsDetailBox").each(function(index) {
                $(this).find(".c-detailPersonalItem").removeClass("opened");
            });
        }

        mobile = false;
    }
}

//
// SPECIALIST PAGE MASONRY PACKAGE
//
$(window).ready(function () {
    ourSpecialistsInit();

    if ($(".c-specialistAboutBox").length != 0 && $(window).width() > 768) {
        setMasonry();
    }
});

$(window).resize(function () {
    ourSpecialistsInit();
});

//
// CLOSE OPENED SPECIALIST CONTENT BOX
//
$(".contentBox .c-closeWindow").on("click", function (e) {
    e.preventDefault();

    $(this).closest(".c-detailPersonalItem").removeClass("opened");

    setMasonry();

    isOpened = false;
});


//
// ADD SCROLLED CLASS TO HEADER AFTER MOBILE SCROLL
//
var lastScrollTop = 0;
$(window).scroll(function (event) {
    var st = $(this).scrollTop();
    if (st > lastScrollTop) {
        if (st > 100) {
            $(".o-header").addClass("scrolled");
        }
    } else {
        if (st < 100) {
            $(".o-header").removeClass("scrolled");
        }
    }
    lastScrollTop = st;
});

//
// OUR SPECIALIST TABS
//


if ($(window).width() > 768) {
    $(".c-personsDetailBox").each(function (index) {
        index == 0 ? $(this).addClass("visible") : false;
    })
}

function setTab(target) {
    var firstIndex = $(".c-personsDetailBox").first().attr("data-detailbox");

    $(".c-personsDetailBox").each(function (index) {
        /* If data detailbox is begining from higher number than 1 */
        if (firstIndex > 1) index += (firstIndex - 1);

        if (index == (target - 1) && $(this).hasClass("visible") && $(window).width() < 768) {
            $(this).removeClass("visible");
        } else {
            index == (target - 1) ? $(this).addClass("visible") : $(this).removeClass("visible");
        }

        if ($(window).width() > 768) {
            setMasonry();
        }

    })
}

$(".c-tabButton[data-detailtarger]").on("click", function (e) {
    e.preventDefault();

    var target = $(this).attr("data-detailtarger");
    setTab(target);
})

$(".c-mobileTabOpener").on("click", function () {
    var target = $(this).attr("data-detailtarger");
    setTab(target);

    $(".c-personsDetailBox[data-detailbox='" + target + "']").find(".c-detailPersonalItem").each(function (index) {
        index == 0 ? $(this).addClass("opened") : $(this).removeClass("opened");
    });
});

/*
    //
    // SHOW NEXT & PREVIOUS DETAIL BOX
    //
*/
$(".c-mobileArrowBox.right").on("click", function (e) {
    e.preventDefault();

    var oldPosition = 0;

    $(this).closest(".c-personsDetailBox").find(".c-detailPersonalItem").each(function (index) {
        $(this).removeAttr("style");

        if ($(this).hasClass("opened")) {
            oldPosition = index;

            $(this).removeClass("opened");
        }
    });

    var elementsCount = $(this).closest(".c-personsDetailBox").find(".c-detailPersonalItem").length;

    if (oldPosition < (elementsCount - 1)) {
        $(this).closest(".c-personsDetailBox").find(".c-detailPersonalItem").each(function (index) {
            index == (oldPosition + 1) ? $(this).addClass("opened") : false;
        });
    } else {
        $(this).closest(".c-personsDetailBox").find(".c-detailPersonalItem:nth-child(1)").addClass("opened");
    }

});
/* end of show next */

$(".c-mobileArrowBox.left").on("click", function (e) {
    e.preventDefault();

    var oldPosition = 0;

    $(this).closest(".c-personsDetailBox").find(".c-detailPersonalItem").each(function (index) {
        $(this).removeAttr("style");

        if ($(this).hasClass("opened")) {
            oldPosition = index;

            $(this).removeClass("opened");
        }
    });

    var elementsCount = $(this).closest(".c-personsDetailBox").find(".c-detailPersonalItem").length;

    if (oldPosition > 0) {
        $(this).closest(".c-personsDetailBox").find(".c-detailPersonalItem").each(function (index) {
            index == (oldPosition - 1) ? $(this).addClass("opened") : false;
        });
    } else {
        $(this).closest(".c-personsDetailBox").find(".c-detailPersonalItem").each(function (index) {
            index == (elementsCount - 1) ? $(this).addClass("opened") : false;
        });
    }

});
/* end of show prev */


/*
    //
    // OUR SPECIALIST CUSTOM SCROLLBAR
    //
*/

$(window).on("load", function () {
    //$(".c-personalDescription").mCustomScrollbar();

});

/*
    //
    // OUR SPECIALIST PERMALINK SMOOTH SCROLL
    //
*/
var urlHash = window.location.hash;
/* If there is doctors detial */
if (urlHash == "#doctorsDetail") {
    $('html, body').animate({
        scrollTop: $(".c-specialistHeader").offset().top - 150
    }, 700);
} else if (urlHash && window.location.search == '') {
    $('html, body').animate({
        scrollTop: $(urlHash).offset().top - 150
    }, 700);
}

$.nette.ext('scrollTop', {
    success: function () {
        var scrollToEl = $('body').find(window.location.hash);
        if (scrollToEl.length > 0) {
            $('html, body').animate({
                scrollTop: scrollToEl.offset().top - 150
            }, 700);
        }
    }
});

/*
    //
    // UNIVERSAL TABS FUNCTION
    //
*/
$(document).on("click", "[data-tabtarget]", function (e) {
    e.preventDefault();

    var target = $(this).attr("data-tabtarget");

    $("div[data-tabelement]").removeClass("visible");

    $("div[data-tabelement='" + target + "']").addClass("visible");
});

/* Show first tabelement on load of page */
if ($("div[data-tabelement]").length != 0) {
    $("div[data-tabelement='1']").addClass("visible");
}

/*
    //
    // DOCTOR DETAIL BACKLINK
    //
*/
function get_hostname(url) {
    var m = url.match(/^http:\/\/[^/]+/);
    return m ? m[0] : null;
}

$('.c-specialistAboutBox').on('click', '.c-backLink', function (e) {
    var currentUrl = get_hostname(window.location.href),
        referrer = get_hostname(document.referrer);
    if (currentUrl === referrer) {
        window.history.back();
        return false;
    }
});

/*
    //
    // LANG SWITCH
    //
*/
$('.app-lang-selector').on('change', function () {
    window.location.href = $(this).val();
});

/*
    //
    // ERROR PAGE 
    //
*/

if ($('.c-errorPage').length != 0 && $(window).width() <= 1200) {
    $('.o-header').addClass('scrolled');
}


/*
    //
    // callback form
    //
*/

$.urlParam = function(name){
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);

    if (results === null) {
        return null;
    }

    return results[1] || 0;
};

function loadDoctors(callbackTeamSelect, callback) {
    $.get(callbackTeamSelect.data('link'), {'teamId': callbackTeamSelect.val()}, function (data) {
        if (data.status == 200) {
            var innerSelectHtml = '<option value="">' + callbackDoctorSelectFirstOption.text() + '</option>';
            $.each(data.items, function (index, value) {
                innerSelectHtml += '<option value="' + index + '">' + value + '</option>';
            });

            $('#frm-callbackForm-form .app-doctor-control').show();
            callbackDoctorSelect.html(innerSelectHtml);

            if (typeof callback === 'function'){
                callback();
            }
        } else {
            $('#frm-callbackForm-form .app-doctor-control').hide();
            callbackDoctorSelect.html('');
        }
    }, 'json');
}

var callbackForm = $('#frm-callbackForm-form');
if (callbackForm.length != 0) {
    var callbackTeamSelect = $('#frm-callbackForm-form-our_doctor_team_id'),
        callbackDoctorSelect = $('#frm-callbackForm-form-our_doctor_id'),
        callbackDoctorSelectFirstOption = callbackDoctorSelect.find('option').first();

    $('#frm-callbackForm-form .app-doctor-control').hide();
    callbackDoctorSelect.html('');

    // init form
    if ($.urlParam('doctorId')) {
        $.get(callbackForm.data('link'), {'doctorId': $.urlParam('doctorId')}, function(data) {
            if (data.status == 200) {
                callbackTeamSelect.val(data.teamId);
                loadDoctors(callbackTeamSelect, function() {
                    callbackDoctorSelect.val(data.doctorId);
                });
            }
        }, 'json');
    }

    // on element change
    callbackTeamSelect.on('change', function () {
        loadDoctors($(this));
    });
}

/*
    //
    // TABBUTTONS MENU ACTIVE CLASS TOOGLE
    //
*/

$('.c-tabButton').on('click', function() {
    $('.c-tabButton').removeClass('active');
    $(this).addClass('active');
});

$('.app-submenu-select').on('click', function(e) {
    e.preventDefault();

    $(this).parent().children('a').toggleClass('open');
});

$('.app-submenu-select').parent().children('a:not(".app-submenu-select")').on('click', function(e) {
    e.preventDefault();
    $('.app-submenu-select').text($(this).text());
    $(this).parent().children('a').removeClass('open');

    history.pushState('', '', $(this).attr('href'));

    $('html, body').animate({
        scrollTop: $($(this).data('hash')).offset().top - 150
    }, 700);
});

$('.c-itemTable .c-itemTable-row:not(.first) .c-itemTable-col:first-of-type').click(function() {
    $(this).parent().toggleClass('open');
});

/*
    //
    // OFFERED METHOD TABS
    //
*/
$('.offeredMethod__component').on('click', '.offeredMethod__component__tabButton', function(e) {
    e.preventDefault();

    if ($(this).hasClass('active')) {
        return false;
    }

    var itemId = $(this).data('item-id');

    $('.offeredMethod__component__tabButton.active').removeClass('active');
    $('.offeredMethod__component__tabContent').hide();

    $(this).addClass('active');
    $('.offeredMethod__component__tabContent[data-item-id="' + itemId + '"]').show();
});
